import React, { useEffect, useState } from 'react';
import { Button, Toast } from 'antd-mobile';
import { Checkbox } from 'antd-mobile-v5';
import { ApiCore } from '../../../api';
import methods from '../../../utils/methods';
import { Encrypt } from "../../../utils/crypto";
import styles from './submit.module.scss';

const api = new ApiCore();

function SubmitComponent(props: any) {

    //设置加载状态
    const [loading, setLoading] = useState(false);
    const [checkedState, setCheckedState] = useState<any>(true);

    useEffect(() => {

        if (props.checked != null) {
            setCheckedState(props.checked)
        }

    }, [])

    //点击确认
    const loginBtn = () => {
        
        if (props.type == 'createaccount') { // 注册账号
            if (!props.username) {
                Toast.fail('请输入姓名！')
                return
            }

            // if (!checkedState) {
            //     Toast.fail('请先同意授权信息！')
            //     return
            // }

            let createAccountData = {
                name: props.username,
                hospital: props.hospital,
                department: props.office,
                title: props.position
            }
            sessionStorage.setItem('createAccountData', JSON.stringify(createAccountData))

            // 补充医患端账号信息
            let currentUserData = sessionStorage.getItem('currentUserData')
            let userData;
            if (currentUserData) {
                userData = JSON.parse(currentUserData)
            }
            
            let params = {
                account: userData.account ?? '',
                accountType: userData.accountType ?? '',
                appCode: userData.appCode ?? '',
                department: props.office,
                hospital: props.hospital,
                name: props.username,
                title: props.position
            }
            setLoading(true)
            api.GetUserCompletion(params).then(res => {
                if (res.code == '0') {
                    // res.data.appCode
                    // res.data.userCode
                    props.history.push({ pathname: `/findList/diseases/diseases`});
                }
                else {
                    setLoading(false)
                    Toast.fail(res.message)
                }
            })

        } else {
            let params = {
                appCode: sessionStorage.getItem('appCode'),
            }
            let imgCode: any = {}

            if (props.type === 'phonenumber') {

                if (!props.phone) {
                    Toast.fail('请输入手机号！')
                    return
                }
                if (props.phone.length < 13) {
                    Toast.fail('请正确输入手机号！')
                    return
                }
                if (!props.graphCodes) {
                    Toast.fail('请输入图形验证码！')
                    return
                }
                if (!props.codes) {
                    Toast.fail('请输入短信验证码！')
                    return
                }

                params['account'] = props.phone ? methods.trim(props.phone, 'g') : ''
                params['accountType'] = 1
                params['verificationCode'] = props.codes

                imgCode['imgCode'] = props.graphCodes

            }
            else if (props.type === 'password') {

                if (!props.account) {
                    Toast.fail('请先输入用户名！')
                    return
                }

                if (!props.password) {
                    Toast.fail('请先输入密码！')
                    return
                }

                params['account'] = props.account
                params['accountType'] = 2
                params['password'] = props.password ? Encrypt(props.password) : ''

            }

            if (!checkedState) {
                Toast.fail('请先同意《用户服务协议》和《隐私政策》！')
                return
            }
            // Object.assign(imgCode, params)
            sessionStorage.setItem('currentUserData', JSON.stringify(params))
            setLoading(true)
            // 查询医患端账号信息
            api.GetDoctorStudioInfo(params).then(res => {
                if (res.code == '0') {
                    if (!res.data && res.data.length == 0) {
                        return
                    }
                    sessionStorage.setItem('affirmUserData', JSON.stringify(res.data))
                    // 手机号已注册->确认用户信息
                    if (res.data.cerStatus == 'CERTIFIED') {
                        props.history.push({ pathname: `/findList/affirm/affirm`, params: res.data });
                    }
                    // 手机号未注册-> 注册
                    else if (res.data.cerStatus == 'UNVERIFIED') {
                        sessionStorage.removeItem('authChecked')
                        sessionStorage.removeItem('paramsList')
                        props.history.push({ pathname: `/findList/createAccount/createAccount` });
                    }
                }
                else {
                    setLoading(false)
                    Toast.fail(res.message)
                }
            })
        }
    }

    const onChange = (e: any, type: any) => {
        if (props.type != 'createaccount') {
            setCheckedState(!checkedState)
        }
    }

    // 协议
    const openAgreement = (type: any, agree: any) => {
        
        let { phone, graphCodes, codes, account, password, graphUrl } = props;
        let echoData = {
            phone,
            graphCodes,
            codes,
            account,
            password,
            graphUrl
        }
        sessionStorage.setItem('echoData', JSON.stringify(echoData))
        sessionStorage.setItem('currentType', type)

        // 关联手机号or关联账号
        if (type == 'phonenumber' || type == 'password') {
            props.history.push(`/findList/comm/agree/agree/${agree}`)
        }
        // 授权信息
        else if (type == 'createaccount') {
            props.history.push({ pathname: `/findList/comm/authorization/authorization` })
        }
    }

    return (
        <div className={styles.login_btn}>
            <Button
                className={styles.btn}
                type="primary"
                disabled={loading}
                onClick={() => loginBtn()}
                loading={loading}
            >
                {props.text}
            </Button>
            <div className={styles.txtWrap}>
                <Checkbox 
                    onChange={(e: any) => onChange(e, props.type)} 
                    checked={checkedState} 
                    indeterminate={checkedState && (props.authorList && props.authorList.length < 4 && props.authorList.length > 0)}
                />&nbsp;&nbsp;
                
                {
                    props.type == 'createaccount' ?
                        <div className={styles.txt}>同意授权使用以上信息，点击选择
                            <span className={styles.link} onClick={(t: any) => openAgreement(props.type, 'info')}> 授权信息</span>
                        </div> :
                        <div className={styles.txt}>我已阅读
                            <span className={styles.link} onClick={(t: any) => openAgreement(props.type, 'service')}>《用户服务协议》</span>和
                            <span className={styles.link} onClick={(t: any) => openAgreement(props.type, 'privacy')}>《隐私政策》</span>
                        </div>
                }

            </div>
        </div>
    )

}

export default SubmitComponent;